/* eslint-disable max-len */
import Image from "next/image";
import Link from "next/link";

import PartnersAndSponsorsLinks from "@/features/partnerAndSponsors/PartnersAndSponsorsLinks";
import { ROUTES } from "@/helpers/routes";
import PageSeo from "@/shared/components/PageSeo";

import Layout from "../../shared/components/layout";

export default function HeadlineSponsors() {
    return (
        <div>
            <PageSeo title="Headline Sponsors | The Gender Index" pathname={ROUTES.headlineSponsors} />
            <Layout>
                <div className='singleLayout type2 partnersPage'>
                    <h3>Partners and sponsors</h3>
                    <p className='body-default-copy-large'>Thank you to our partners and sponsors who make it possible for The Gender Index to exist, click on the logos below to learn more about why they are supporting The Gender Index.</p>
                    <PartnersAndSponsorsLinks />
                    <div className='partnerBanner type2'>
                        <div className="container">
                            <div className="grid-wrapper">
                                <div className="row justify-content-center">
                                    {/* <div className="col-12 col-lg-4">
                                        <figure>
                                            <Image
                                                src="/images/PartnerLogos/aws-new.png"
                                                alt="logo_image"
                                                width={200}
                                                height={100}
                                                loading="lazy"
                                            />
                                        </figure>
                                        <p className='body-default-copy threeLinerText textCenter'>AWS provides its customers, including financial services institutions, the ability to differentiate today and adapt to
                                            tomorrow by empowering them to modernise their infrastructure, meet rapidly changing consumer behaviours and
                                            expectations, and drive business growth—all while supporting the most stringent security, compliance, and regulatory
                                            requirements.</p>
                                        <Link href='/headline-sponsors/amazon-web-services'><button className="btn-red-outlined btn-reset">Read More</button></Link>
                                    </div> */}
                                    {/* <div className="col-12 col-lg-4">
                                        <figure>
                                            <Image
                                                src="/images/PartnerLogos/goldman-new.jpg"
                                                alt="logo_image"
                                                width={250}
                                                height={150}
                                                loading="lazy"
                                            />
                                        </figure>
                                        <p className='body-default-copy threeLinerText textCenter'>Goldman Sachs 10,000 Small Businesses UK is an investment to help entrepreneurs create jobs and economic opportunity by providing business and management training to high-growth small business owners in the UK.</p>
                                        <Link href='/headline-sponsors/goldman-sachs'><button className="btn-red-outlined btn-reset">Read More</button></Link>
                                    </div> */}
                                    <div className="col-12 col-lg-4">
                                        <figure>
                                            <Image
                                                src="/images/PartnerLogos/dwf.png"
                                                alt="logo_image"
                                                width={250}
                                                height={150}
                                                loading="lazy"
                                            />
                                        </figure>
                                        <p className='body-default-copy threeLinerText textCenter'>DWF is a leading global provider of integrated legal and business services, with a purpose to deliver positive outcomes with our colleagues, clients and communities.</p>
                                        <Link href='/headline-sponsors/dwf'><button className="btn-red-outlined btn-reset">Read More</button></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </div>
    );
}

